import { IoIosWarning } from 'react-icons/io';

const AccessDeniedCard = () => (
  <div className="flex flex-col items-center text-center p-8 bg-white max-w-[400px] rounded-xl shadow-md border border-[#f0f0f0]">
    <IoIosWarning fontSize={40} color="#AD2101" />
    <h1 className="font-figtree text-xl font-bold text-[#AD2101] mt-4">Access Denied</h1>
    <p className="text-base font-medium font-figtree text-[#595959] mt-2">
      You don&apos;t have permission to access this application. Contact an administrator to request an invitation.
    </p>
  </div>
);

export default AccessDeniedCard;
